/***************************************************************************************************
** getOptionsFromSrc
***************************************************************************************************/

import Constants from "@utils/Constants";

const SCHEMES = [
  "enums",
  "constants",
];

export default function getOptionsFromSrc(src) {
  if (!src) return null;
  if (typeof(src) !== "string") return null;

  const [scheme, path] = src.split("://");
  if (!SCHEMES.includes(scheme)) return null;

  const [category, field] = path.split("/");

  switch (scheme) {
  case "enums":
    return ENUMS?.[category]?.[field];
  case "constants":
    return Constants[path.toUpperCase()];
  default:
    return [];
  }
}
